import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  BackButton,
  Container,
  HeaderWrapper,
  StyledChevronLeft,
  Title,
  Wrapper,
} from './styles';
import { useSelector } from 'react-redux';
import { navigationUrl } from '../../store/analytic/actions';
import { useHistory } from 'react-router-dom';

const FAQ: React.FC = () => {
  const faqText = useSelector((state: ApplicationState) =>
    state.config.textoFaq.toString()
  );

  const dispatch = useDispatch();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/faq',
      })
    );
  }, [dispatch]);

  return (
    <Wrapper>
      <Container>
        <HeaderWrapper>
          <BackButton onClick={handleGoBack}>
            <StyledChevronLeft />
            Voltar
          </BackButton>
          <Title>F.A.Q.</Title>
        </HeaderWrapper>
        <div dangerouslySetInnerHTML={{ __html: faqText }} />
      </Container>
    </Wrapper>
  );
};

export default FAQ;
